import { baseApiService } from "./baseApiService";
import { buildBlobProxyUrl } from "../utils/blobProxyUrl";

export interface CompanyLegendSymbolSummaryDto {
  id: string;
  iconBlobPath: string | null;
  name: string;
  createdBy: string;
  status: "pending" | "approved" | "rejected";
  lastUpdatedDate: string;
  isApproved: boolean;
}

// SymbolKey is derived server-side from name; IsApproved/Status default to approved for
// user-created symbols.
export interface CreateCompanySymbolItemDto {
  base64File: string;
  fileName: string;
  contentType?: string;
  name: string;
  description?: string;
}

const normalizeSymbol = (
  symbol: CompanyLegendSymbolSummaryDto
): CompanyLegendSymbolSummaryDto => ({
  ...symbol,
  iconBlobPath: symbol.iconBlobPath
    ? buildBlobProxyUrl(symbol.iconBlobPath)
    : symbol.iconBlobPath,
});

export const technicalEstimateLegendService = {
  // Server-side already excludes deleted symbols and scopes by companyId.
  getByCompanyId: (companyId: string) =>
    baseApiService
      .get<CompanyLegendSymbolSummaryDto[]>(
        `/technical-estimate/legends/company/${companyId}`
      )
      .then((symbols) => symbols.map(normalizeSymbol)),

  setApproval: (id: string, action: "Approve" | "Reject") =>
    baseApiService.patch<void>(`/technical-estimate/legends/${id}/approval`, {
      action,
    }),

  createSymbols: (companyId: string, symbols: CreateCompanySymbolItemDto[]) =>
    baseApiService.post<unknown[]>("/technical-estimate/legends", {
      companyId,
      symbols,
    }),

  // Edit is name-only by design — the icon cannot be changed after creation.
  updateSymbol: (id: string, companyId: string, name: string) =>
    baseApiService.put<void>("/technical-estimate/legends", {
      id,
      companyId,
      name,
    }),

  // Soft delete only — the backend never removes the record or its blob.
  deleteSymbol: (id: string) =>
    baseApiService.delete<void>(`/technical-estimate/legends/${id}`),
};
